var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center text-white hover:text-gray-300 transition-colors duration-300 font-lato",on:{"click":_vm.goBack}},[_c('span',{staticClass:"mdi mdi-arrow-left text-xl"})])
}
var staticRenderFns = []

export { render, staticRenderFns }